import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightningBolt: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="lightning-bolt, speed, thunder, flash, high woltage"><path d="M11.8034 3.02149C12.9085 1.50152 15.3061 2.55449 14.9343 4.39649L13.9528 9.25H17.2878C18.7175 9.25034 19.5433 10.8727 18.7028 12.0293L12.198 20.9785C11.0929 22.4987 8.69526 21.4456 9.06709 19.6035L10.0485 14.75H6.71358C5.28366 14.7499 4.45782 13.1274 5.29854 11.9707L11.8034 3.02149Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLightningBolt;
